import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { Nav, Tab, Tabs } from 'react-bootstrap';
import { PvMonitoringContext } from '../../../../context/PvMonitoringContext';

import { WEB_KEY, PASS_KEY } from '../../../../api/AxiosApi';
import TopHeader from '../../../../components/general/TopHeader';
import Loading from '../../../../components/loading/Loading';
import DataNotFound from '../../../../components/error/DataNotFound';
import Inverter1Tabs from '../inverter1/tabs/Inverter1Tabs';
import RelayTabs from './RelayTabs/RelayTabs';


export default function Relay() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
    const { getPvMnMenu_INV, PvMnMenuData_INV, Pv_MnMenu_INV_Loading } = useContext(PvMonitoringContext)
    const LOGIN_ID = sessionStorage.getItem('LoginID')
    const LOC_CODE = sessionStorage.getItem('LCODE')
    const TYE = "R"
    const [key, setKey] = useState('');

    

    useEffect(() => {
        if (PvMnMenuData_INV && PvMnMenuData_INV?.length > 0) {
            setKey(PvMnMenuData_INV[0]?.FEEDER_ID);
        }
    }, [PvMnMenuData_INV]);

    useEffect(() => {
        getPvMnMenu_INV(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYE)
    }, [LOGIN_ID])

    return (
        <>
            <CssBaseline />
            <TopHeader />
            <Box py={spacing(1)} bgcolor={'background.default'}>
                {
                    Pv_MnMenu_INV_Loading ? <Loading /> :
                        PvMnMenuData_INV?.length <= 0 ?
                            <DataNotFound /> :
                            <Tabs
                                style={{ justifyContent: "flex-end", }}
                                id="controlled-tab-example"
                                activeKey={key}
                                onSelect={(k) => setKey(k)}
                            >
                                {

                                    PvMnMenuData_INV?.map((item, index) => {
                                        return (
                                            <Tab key={index} eventKey={item?.FEEDER_ID} title={item?.NAME}>
                                                <RelayTabs TabTitle={item?.NAME} ID={key} />
                                            </Tab>
                                        )
                                    })


                                }


                            </Tabs>




                }


            </Box>   676
        </>

    )
}